import { Box, MenuItem, Select, Typography, Button } from "@mui/material";
import React from "react";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { LoadingSlides } from "../CommonComponents/Common";

const LinkBody = ({ obj }) => {
  const {
    projectName,
    selectedBot,
    workflowList,
    setSelectedWorkflow,
    selectedWorkflow,
    handleAddWorkflow,
    spin,
    setModal,
    updateParamsForSelection,
  } = obj;

  return (
    <Box p={3}>
      <Box>
        <Typography className="font-14-grey" mb={1}>
          Project Name - <strong>{projectName(selectedBot)}</strong>
        </Typography>
        <Typography className="font-14-grey" mb={1}>
          Brand Name - <strong>{selectedBot?.brandName}</strong>
        </Typography>
        <Typography className="font-14-grey" mb={1}>
          Demo Bot Url -{" "}
          <strong>{`${selectedBot?.link}?aid=${selectedBot?._id}&w=true`}</strong>
        </Typography>
      </Box>

      <Box mb={2}>
        <Typography className="font-14-600-grey" mb={0.5}>
          Currently Linked Workflow:
        </Typography>
        <Box display="flex" flexWrap="wrap" gap={1} mb={1}>
          {selectedBot?.workflow ? (
            workflowList
              ?.filter((wf: any) => wf.id === selectedBot.workflow)
              .map((wf: any) => (
                <Box
                  key={wf.id}
                  px={1.5}
                  py={0.5}
                  border="1px solid #4caf50"
                  borderRadius={2}
                  fontSize="0.8rem"
                  color="#4caf50"
                  bgcolor="#f1f8e9"
                >
                  {wf?.name}
                </Box>
              ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No workflow currently linked
            </Typography>
          )}
        </Box>
      </Box>

      <Box>
        <Typography className="font-14-grey" mb={0.5}>
          Add New Workflow:
        </Typography>
        <Select
          fullWidth
          displayEmpty
          value={selectedWorkflow}
          onChange={(e) => {
            const value = e.target.value;
            setSelectedWorkflow(value);
            updateParamsForSelection(value);
          }}
          renderValue={(selected) =>
            !selected
              ? "Select workflow"
              : workflowList.find((item: any) => item.id === selected)?.name ||
                ""
          }
          sx={{ mb: 3, ...commonStyles.customSelectStyle }}
        >
          {workflowList?.map((workflow: any, idx) => (
            <MenuItem key={`idx-${idx + 1}`} value={workflow?.id}>
              <Typography className="font-13-grey">{workflow?.name}</Typography>
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Button
          onClick={() => {
            setModal(false);
            setSelectedWorkflow("");
          }}
          sx={{ mr: 2 }}
        >
          Cancel
        </Button>
        <Button
          disabled={spin || !selectedWorkflow}
          variant="contained"
          onClick={handleAddWorkflow}
        >
          {spin ? <LoadingSlides bgColor="white" /> : "Add Workflow"}
        </Button>
      </Box>
    </Box>
  );
};

export default LinkBody;
